import { Typography } from "@mui/material";

export function DivergentIndicatorsItem(props: {
  label: string;
  value: string | number | undefined | null;
}) {
  const { label, value } = props;
  return (
    <div className="d-flex w-50 px-2 flex-row justify-content-between">
      <Typography fontSize={12}>{label}:</Typography>
      <Typography fontSize={12}>{value ?? "Não informado"}</Typography>
    </div>
  );
}
